import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Spinner from '../Utils/Spinner';
import Header from '../Main/Header';

const Episodes = () => {
    const params = useParams();
    const watchId = params.watchId;
    const season = params.season;

    const [data, setData] = useState();
    const [searchParams, setSearchParams] = useSearchParams();

    const [error, setError] = useState();
    const navigate = useNavigate();

    const url =
        'https://api.themoviedb.org/3/tv/' +
        watchId +
        '/season/' +
        season +
        '?api_key=d0e6107be30f2a3cb0a34ad2a90ceb6f';
    useEffect(() => {
        axios
            .get(url)
            .then((response) => {
                setData(response.data);
            })
            .catch((error) => {
                const errorMessage = error.response ? error.response.data : error.message;
                setError(errorMessage);
            });
    }, []);

    const openepisode = (episode) => {
        navigate(
            '/watch/tv/' + watchId + '/season/' + season + '/episode/' + episode + '?title=' + searchParams.get('title')
        );
    };
    return (
        <>
            {data &&
                data.episodes.map(function (episode, index) {
                    const overview = episode.overview;
                    const truncatedOverView = overview.length > 100 ? overview.substring(0, 250) + '...' : overview;

                    return (
                        <React.Fragment key={index}>
                            <div
                                className='flex text-white border-gray-600 shadow-md mb-5 cursor-pointer rounded'
                                onClick={() => openepisode(episode.episode_number)}
                            >
                                <img
                                    className='w-36 h-24 shadow-md rounded-lg m-2 object-cover'
                                    src={`https://image.tmdb.org/t/p/w400${episode.still_path}`}
                                    alt=''
                                />
                                <div>
                                    <div className='font-semibold text-sm'>{episode.name}</div>
                                    <div className='text-xs font-medium mb-2'>{truncatedOverView}</div>
                                    <div className='flex justify-between'>
                                        <span className='text-xs'>Aired on: {episode.air_date}</span>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    );
                })}
        </>
    );
};

export default Episodes;
